import { OnDestroy, OnInit, Output, EventEmitter, Injectable, Directive } from '@angular/core';
import { FormService } from '../../services/form/form.service';
import { SubjectManager } from '../../../../common/js/subjectManager/SubjectManager';
import { ValidationService } from '../../services/validation/validation.service';
import { FormatterService } from '../../services/formatter/formatter.service';

@Directive()
export abstract class BaseFormComponent implements OnInit, OnDestroy {
  public componentId: string;
  public prop: string;
  protected formService: FormService;
  protected validationService: ValidationService;
  protected formatterService: FormatterService;
  public errorMessage: {} = {};
  protected optional: boolean;
  @Output() valueChanged: EventEmitter<void> = new EventEmitter();
  @Output() onBlur: EventEmitter<void> = new EventEmitter();

  ngOnDestroy() {}

  ngOnInit() {}

  protected abstract updateFromModel();

  protected getValue(prop: string) {
    return this.formService.getValue(prop);
  }

  protected setValue(prop: string, value): void {
    this.formService.setValue(prop, value);
  }

  async validateAndSet(prop: string, value): Promise<boolean> {
    const isEmpty = value === null || value === undefined || value.length === 0;

    // First parse the value to the right model type
    let parsedValue = this.parse(prop, value);

    // If the parse function expect a number and receives non-numeric input,
    // it returns null, causing the validation service to fail the required rule.
    // If the value parsed to null but was originally not empty, we set the
    // parsedValue back to the entered value.
    if (!isEmpty && parsedValue === null) {
      parsedValue = value;
    }

    // Now validate against rules, validators in the model
    const isValid = await this.validateProp(prop, parsedValue);

    if (isValid || (this.optional && isEmpty)) {
      this.submitValueAndFireTriggers(prop, parsedValue);
      return true;
    } else {
      return false;
    }
  }

  protected parse(prop: string, value): string {
    return this.formService.parse(prop, value);
  }

  protected format(formatterType: string, val) {
    return this.formService.format(formatterType, val);
  }

  private fireTrigger(prop: string): void {
    this.formService.fireTrigger(prop);
  }

  private submitValueAndFireTriggers(prop: string, value): void {
    this.setValue(prop, value);
    this.fireTrigger(prop);
    const propertyName = prop.replace(/(\.)/g, '_') + '_changed';
    SubjectManager.publish(propertyName);
  }

  protected async validateProp(prop: string, value): Promise<boolean> {
    this.errorMessage[prop] = '';

    const result = await this.formService.runModelValidation(prop, value);
    if (!result[ValidationService.RESULT]) {
      this.errorMessage[prop] = result[ValidationService.ERR_MSG];
      return false;
    }

    return true;
  }
}
